/**
 * Live flag for the opt-in smart-typography input rules (see
 * ProseEditor/smartTypography.ts). Kept in its own tiny, dependency-free module so
 * App can keep it in sync with the persisted setting WITHOUT pulling the TipTap
 * editor code into the eager boot bundle. The lazy editor reads `.current` when a
 * rule fires, so toggling the setting takes effect with no editor remount.
 */
export const smartTypographyEnabled = { current: false }
